// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__Y4pXF","additionalInfo":"AgreementModal_additionalInfo__11FrF"};